<template>
  <div class="image-upload-wrapper">
    <el-upload ref="upload" 
    :action="uploadUrl" 
    list-type="picture-card" 
    :file-list="innerFileList"
    :http-request="customUpload" 
    :limit="limit"
    :multiple="true" 
    :on-exceed="handleExceed" 
    :before-upload="beforeUpload"
    :on-remove="handleRemove" 
    :on-preview="handlePreview" 
    :on-success="handleSuccess" 
    :on-error="handleError"
    :on-progress="handleProgress" 
    :auto-upload="autoUpload" 
    :accept="acceptString" 
    :headers="headers"
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.url" :alt="file.name" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
        <div v-if="file.status === 'uploading'" class="upload-progress">
          <el-progress :percentage="file.percentage" :stroke-width="16" status="success" text-inside></el-progress>
        </div>
      </div>
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传{{ fileTypeText }}，单张不超过{{ maxSize }}MB
      </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body :title="currentPreviewFile ? currentPreviewFile.name : ''">
      <img width="100%" :src="dialogImageUrl" :alt="currentPreviewFile ? currentPreviewFile.name : ''">
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ImageUpload',
  props: {
    // 上传地址
    uploadUrl: {
      type: String,
      required: true
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => []
    },
    // 最大上传数量
    limit: {
      type: Number,
      default: 3
    },
    // 单文件大小限制(MB)
    maxSize: {
      type: Number,
      default: 2
    },
    // 允许的文件类型
    acceptTypes: {
      type: Array,
      default: () => ['image/jpeg', 'image/png', 'image/gif']
    },
    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default: true
    },
    // 是否显示提示
    showTip: {
      type: Boolean,
      default: true
    },
    // 请求头
    headers: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      innerFileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      currentPreviewFile: null
    }
  },
  computed: {
    fileTypeText() {
      return this.acceptTypes.map(t => t.split('/')[1].toUpperCase()).join('、')
    },
    acceptString() {
      return this.acceptTypes.map(type => `.${type.split('/')[1]}`).join(',')
    }
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log('图片数量的监听=', val)
        this.innerFileList = val
      },
    }
  },
  methods: {
    // 自定义上传方法
    customUpload(options) {
      const formData = new FormData();

      // 添加文件参数（根据后端要求调整参数名）
      formData.append('file', options.file);

      // 创建axios请求
      axios.post(this.uploadUrl, formData, {
        headers: {
          ...this.headers,
          'Content-Type': 'multipart/form-data' // 必须显式设置
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$emit('progress', percentCompleted, options.file);
        }
      })
        .then(response => {
          console.log('到这里了=',response)
          if (response.data.code === 200) {
            this.innerFileList.push(response.data.data)
            this.$emit('success', response.data, options.file);
            this.$emit('update:fileList', this.innerFileList)
          } else {
            this.$message.warning(response.msg)
          }
        })
        .catch(error => {
          this.$emit('error', error, options.file);
        });
    },
    // 文件上传前校验
    beforeUpload(file) {
      const isTypeValid = this.acceptTypes.includes(file.type)
      const isSizeValid = file.size / 1024 / 1024 < this.maxSize

      if (!isTypeValid) {
        this.$message.error(`请上传${this.fileTypeText}格式的图片`)
        return false
      }
      if (!isSizeValid) {
        this.$message.error(`图片大小不能超过${this.maxSize}MB`)
        return false
      }
      return true
    },

    // 超出数量限制
    handleExceed() {
      this.$message.warning(`最多只能上传${this.limit}张图片`)
    },

    // 删除文件
    handleRemove(file) {
      console.log('删除=', file)
      console.log('innerFileList=', this.innerFileList)
      const index = this.innerFileList.findIndex(f => f.url === file.url)
      if (index !== -1) {
        this.innerFileList.splice(index, 1)
        this.$emit('remove', file)
        this.$emit('update:fileList', this.innerFileList)
      }
    },

    // 预览图片
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.currentPreviewFile = file
      this.dialogVisible = true
    },

    // 上传结果
    handleSuccess(response, file, fileList) {
      console.log('请求返回response=', response, '===file====', file, '===fileList====', fileList)
      if (response.data.code === 200) {
        this.$emit('success', response, file, fileList)
        this.$emit('update:fileList', fileList)
      } else {
        this.$message.warning(response.msg)
      }

    },

    // 上传失败
    handleError(err, file, fileList) {
      this.$emit('error', err, file, fileList)
      this.$message.error(`文件${file.name}上传失败`)
    },

    // 上传进度
    handleProgress(event, file, fileList) {
      this.$emit('progress', event, file, fileList)
    },

    // 手动上传方法
    submitUpload() {
      this.$refs.upload.submit()
    },

    // 清空文件列表
    clearFiles() {
      this.$refs.upload.clearFiles()
      this.innerFileList = []
      this.$emit('update:fileList', [])
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.el-upload-list__item) {
  height: 86px !important;
  width: 86px !important;
}

.image-upload-wrapper {
  border-radius: 4px;
  background-color: #fff;
}

.el-upload-list__item-thumbnail {
  object-fit: cover;
  transition: all 0.3s ease;
}

.el-upload-list__item:hover .el-upload-list__item-thumbnail {
  transform: scale(1.05);
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
}

.upload-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 5px;
}

.el-upload-list__item-actions {
  transition: opacity 0.3s;
}

.el-upload-list__item:hover .el-upload-list__item-actions {
  opacity: 1;
}
</style>